// Messages for operator/Sessions (auto-merged by lib/i18n.ts).
export const en = {
  'operator.sessions.head': 'Sessions — Operator',
  'operator.sessions.title': 'Active sessions',
  'operator.sessions.desc': 'Devices currently signed in to your account.',
  'operator.sessions.unknown_device': 'Unknown device',
  'operator.sessions.this_session': '· this session',
  'operator.sessions.unknown_ip': 'unknown IP',
  'operator.sessions.last_active': '· last active {time}',
  'operator.sessions.sign_out': 'Sign out',
  'operator.sessions.revoke': 'Revoke',
}

export const zhTW = {
  'operator.sessions.head': '工作階段 — 操作端',
  'operator.sessions.title': '使用中的工作階段',
  'operator.sessions.desc': '目前已登入您帳戶的裝置。',
  'operator.sessions.unknown_device': '未知裝置',
  'operator.sessions.this_session': '· 此工作階段',
  'operator.sessions.unknown_ip': '未知 IP',
  'operator.sessions.last_active': '· 最後使用 {time}',
  'operator.sessions.sign_out': '登出',
  'operator.sessions.revoke': '撤銷',
}
